import { useTheme } from "@emotion/react";
import { produce, setAutoFreeze } from "immer";

import mergeProps from "./mergeProps";

setAutoFreeze(false);

/**
 * Returns the props to use for a component, merging the default props from the theme.
 * @param {Object} props The props that were passed to the component
 * @param {string} name The name of the component
 * @returns {Object} The props to use for the component
 */
export default function useThemeProps({
  props,
  name,
  handleVariant = false,
  context = {},
}) {
  const theme = useTheme();
  let { defaultProps = {}, transformProps = [] } =
    theme.components?.[name] || {};
  if (transformProps && !Array.isArray(transformProps)) {
    transformProps = [transformProps];
  }
  props = transformProps.reduce((props, transform) => {
    return produce(props, (props) => transform(props, context));
  }, props);
  if (handleVariant) {
    let propsWithDefaults = mergeProps(defaultProps, props);
    let variant = propsWithDefaults.variant;
    const variantProps =
      (variant && theme.components?.[name]?.variants?.[variant]) || {};
    defaultProps = mergeProps(defaultProps, variantProps);
  }
  props = mergeProps(defaultProps, props);
  if (handleVariant) {
    delete props.variant;
  }
  return props;
}
